import React from 'react';
import xhr from 'xhr';
import { CSRF_TOKEN } from 'constants';

class APIToken extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      memberId: this.props.memberId,
      apiTokenId: this.props.apiTokenId,
      apiToken: this.props.apiToken,
      apiTokenLastRequestAt: this.props.apiTokenLastRequestAt,
      apiTokenLastRequestIp: this.props.apiTokenLastRequestIp,
      apiTokenVisible: this.props.apiTokenVisible,
      regenerateLinkText: 'Regenerate'
    };

    this.regenerateApiToken = this.regenerateApiToken.bind(this);
  }

  regenerateApiToken(e) {
    e.preventDefault();

    if (confirm("This API token will stop working and a new one will be created. Are you sure?")) {
      this.setState({
        regenerateLinkText: 'Regenerating...'
      });

      xhr(`/api_tokens/${this.state.apiTokenId}/expire.json`, {
        headers: { 'X-CSRF-Token': CSRF_TOKEN },
        method: 'POST',
        onSuccess: (response) => {
          this.setState({
            apiTokenId: response.token.id,
            apiToken: response.token.value,
            apiTokenLastRequestAt: null,
            apiTokenLastRequestIp: null,
            regenerateLinkText: 'Regenerate'
          });

          PT.ApiToken = response.token.value;
        }
      });
    }
  };

  render() {
    if (!this.state.apiTokenVisible) { return(null); }

    const shouldShowMetaData = this.state.apiTokenLastRequestAt && this.state.apiTokenLastRequestIp;

    return (
      <div className="grid flex">
        <div className="grid-cell mod-token">
          <h4>API Token</h4>

          <div className="api-token">
            <code>{this.state.apiToken}</code> &rarr; <a href="/account/profile" onClick={this.regenerateApiToken}>{this.state.regenerateLinkText}</a>
            {
              shouldShowMetaData &&
                <div className="token-meta">
                  <p>Last used: {this.state.apiTokenLastRequestAt}</p>
                  <p>From: {this.state.apiTokenLastRequestIp}</p>
                </div>
            }
          </div>

          <span className="tip">
            Learn about <a href="https://github.com/papertrail/papertrail-cli">command-line client</a>
            {" and "}
            <a href="http://help.papertrailapp.com/kb/how-it-works/http-api">HTTP API</a>.
          </span>
        </div>
      </div>
    );
  }
}

export default APIToken;
